import axios from 'axios';
import config from '../../common/config/env'; 
import { axiosAuthInterceptor } from '../../apps/kogan/apis/authInterceptor';


const OpenAIApi = axios.create({
    baseURL: `${config.openAIBaseUrl}`
    
});


OpenAIApi.interceptors.request.use(config=>{
    config.headers['version'] = 'v1';
    return config;
}, (error)=> Promise.reject(error));

OpenAIApi.interceptors.request.use(
    axiosAuthInterceptor,
    (error)=> Promise.reject(error)
);



export default OpenAIApi;

